module.exports = __webpack_public_path__ + "img/b332583.jpg";